import { ApiRequest, RequestMethod } from "../../request";
import { RecentTeam } from "../../../model/Dto/ReсentTeamsDto";

export async function getLeaderboard(): Promise<RecentTeam[]> {
    const apiRequest = new ApiRequest();
    apiRequest.setMethod(RequestMethod.GET);
    apiRequest.setUrl("/api/team/leaderboard");
    const response: any = await apiRequest.send();
    return response.data ?? [];
}
